module.exports = __webpack_public_path__ + "img/banner2.720af54.jpg";